import { i18nDefaultLocale, TLanguage } from "@/i18Config"
import {
  AzureKeyCredential,
  SearchClient,
  SearchDocumentsResult,
  SelectFields,
} from "@azure/search-documents"
import { env } from "env"

export interface SearchItem {
  Codename?: string
  Title?: string | null
  Description?: string | null
  Path?: string | null
  Type?: string
  ImageUrl?: string | null
}

export const PAGE_SIZE = 10

export async function searchItems(
  searchText: string,
  language: TLanguage = i18nDefaultLocale,
  page: number = 1
): Promise<SearchDocumentsResult<SearchItem, SelectFields<SearchItem>>> {
  const SearchClientAzure = new SearchClient<SearchItem>(
    env.NEXT_PUBLIC_SEARCH_ENDPOINT,
    env.NEXT_PUBLIC_SEARCH_INDEX + "_" + language,
    new AzureKeyCredential(env.NEXT_PUBLIC_SEARCH_ADMIN_KEY)
  )

  return await SearchClientAzure.search(searchText + "*", {
    includeTotalCount: true,
    top: PAGE_SIZE,
    skip: (page - 1) * PAGE_SIZE,
  })
}
